
import { computed, ref, onMounted } from "vue";

export const ESCALA_MINIMA = 0.8;
export const ESCALA_MAXIMA = 1.5;
const PASSO = 0.1;

const fontScale = ref(1.0);

const isClient = typeof window !== 'undefined' && typeof document !== 'undefined';

// Uma casa decimal: evita 1.5000000000000002 depois de vários cliques.
const arredondar = (valor) => Math.round(valor * 10) / 10;

const initFontScale = () => {
    if (!isClient) return;

    try {
        const saved = localStorage.getItem("fontScale");
        if (saved) {
            const parsed = parseFloat(saved);
            if (!isNaN(parsed) && parsed >= ESCALA_MINIMA && parsed <= ESCALA_MAXIMA) {
                fontScale.value = parsed;
            }
        }
    } catch {
        // sem armazenamento: usa a escala atual
    }
    applyFontScale(fontScale.value);
};

const applyFontScale = (scale) => {
    if (!isClient) return;
    document.documentElement.style.setProperty("--font-scale", scale.toString());
};

const salvar = (scale) => {
    try {
        if (scale === 1.0) localStorage.removeItem("fontScale");
        else localStorage.setItem("fontScale", scale.toString());
    } catch {
        // sem armazenamento: vale até recarregar a página
    }
};

const definir = (scale) => {
    if (!isClient) return;
    fontScale.value = arredondar(Math.min(ESCALA_MAXIMA, Math.max(ESCALA_MINIMA, scale)));
    salvar(fontScale.value);
    applyFontScale(fontScale.value);
};

const increaseFont = () => definir(fontScale.value + PASSO);

const decreaseFont = () => definir(fontScale.value - PASSO);

const resetFont = () => definir(1.0);

const podeAumentar = computed(() => fontScale.value < ESCALA_MAXIMA);
const podeDiminuir = computed(() => fontScale.value > ESCALA_MINIMA);

export function useFontScale() {
    onMounted(() => {
        initFontScale();
    });

    return {
        fontScale,
        increaseFont,
        decreaseFont,
        resetFont,
        podeAumentar,
        podeDiminuir,
    };
}
